export default "__VITE_ASSET__BUH2y_fT__"